import { render, staticRenderFns } from "./XML.vue?vue&type=template&id=2e19a68c"
import script from "./XML.vue?vue&type=script&lang=js"
export * from "./XML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports